module.exports = __webpack_public_path__ + "img/download.c35c6b2a.svg";